import {evenementsRetenus} from './etat.js';

// F9 : RSE estimée sur les événements retenus. `rseSnapshot` = `snapshot.rse` ({eau: {matrice}, km: {kmMoyenParTournee}}).

const cachesRse = new WeakMap(); // index -> WeakMap<tableau pavs, Map<paramètres, résultat>>

/** RSE des PAV donnés sur la plage, mémoïsée (même contrat de stabilité de `pavs` que `evenementsRetenus`). */
export function rseRetenue(index, pavs, params) {
    let parPavs = cachesRse.get(index);
    if (!parPavs) cachesRse.set(index, (parPavs = new WeakMap()));
    let cache = parPavs.get(pavs);
    if (!cache) parPavs.set(pavs, (cache = new Map()));
    const cle = `${params.du || ''}|${params.au || ''}|${params.at || ''}`;
    let res = cache.get(cle);
    if (!res) {
        res = rse(evenementsRetenus(index, pavs, params), index.snapshot.rse);
        cache.set(cle, res);
        if (cache.size > 8) cache.delete(cache.keys().next().value);
    }
    return res;
}

export function rse(evenementsRetenus, rseSnapshot) {
    const matrice = (rseSnapshot && rseSnapshot.eau && rseSnapshot.eau.matrice) || null;
    const kmMoyen = rseSnapshot && rseSnapshot.km ? rseSnapshot.km.kmMoyenParTournee : null;

    let eauLitres = matrice ? 0 : null;
    const tournees = new Set();
    const pavsLaves = new Set();

    for (const e of evenementsRetenus) {
        if (e.type !== 'LAVAGE' && e.type !== 'IMPOSSIBLE') continue;
        tournees.add(`${e.date}|${e.patrimoineId}`);
        if (e.type !== 'LAVAGE') continue;
        pavsLaves.add(e.pavId);
        const conso = matrice && e.detail ? matrice[e.detail.typologie] : null;
        if (conso != null && e.detail.nombreLaves != null) eauLitres += e.detail.nombreLaves * conso;
    }

    const nbTournees = tournees.size;
    const km = kmMoyen != null ? nbTournees * kmMoyen : null;
    return {
        eauLitres,
        eauEconomisee: null, // aucune base de comparaison en V1
        km,
        kmParPavLave: km != null && pavsLaves.size > 0 ? km / pavsLaves.size : null,
        nbTournees,
    };
}
